import { ComposedTheme, registerDefaultsForModule } from '@glu/theming';
import legacy from './themes/legacyTheme';
import ash from './themes/ashTheme';

registerDefaultsForModule('formComponents', (theme: ComposedTheme) => {
  const { name } = theme;
  if (name === 'ash') {
    return ash(theme);
  }
  return legacy(theme);
});
